import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { uniqWith, equals, path } from 'ramda';

const removeDuplicatesByNestedProps = (objects: GenericObject[], nestedProps: string[]) =>
  uniqWith((obj1, obj2) => equals(path(nestedProps, obj1), path(nestedProps, obj2)), objects);

export { removeDuplicatesByNestedProps };
